import { createAsyncThunk, createSlice } from '@reduxjs/toolkit';
import axios from '../../utils/axios';

const initialState = {
  currentPlan: '',
  nextPlan: '',
  mailingOption: '',
  nextMailingOption: '',
  packages: {},
  currentPlanStatus: 'idle',
  currentPlanStatusMsg: '',
  firstName: '',
  packagesDetail: [],
};

export const fetchCurrentPlan = createAsyncThunk('enhance-dispute/fetchCurrentPlan', async () => {
  let accessToken = localStorage.getItem('accessToken');
  let formData = new FormData();
  formData.append('Token', accessToken);
  let response = await axios.post('form/getClientByCompanyId', formData);
  if (response.status === 200) {
    if (response.data.error != 2) {
      return response.data;
    } else {
      removeLocalStorage();
      window.location.href = '/';
    }
  } else {
    throw new Error(response.statusText);
  }
});

export const fetchPackagesDetail = createAsyncThunk('enhance-dispute/fetchPackagesDetail', async () => {
  let accessToken = localStorage.getItem('accessToken');
  let formData = new FormData();
  formData.append('Token', accessToken);
  let response = await axios.post('form/packagesListingValues', formData);
  if (response.status === 200) {
    if (response.data.error != 2) {
      delete response.data.error;
      return response.data;
    } else {
      removeLocalStorage();
      window.location.href = '/';
    }
  } else {
    throw new Error(response.statusText);
  }
});

export const updateCurrentPlan = createAsyncThunk('enhance-dispute/updateCurrentPlan', async ({ planId, mailingOption }) => {
  try {
    let accessToken = localStorage.getItem('accessToken');
    let formData = new FormData();
    formData.append('Token', accessToken);
    formData.append('current_plan', planId);
    formData.append('mailing_option', mailingOption);
    let response = await axios.post('form/setCurrentPlan', formData);
    if (response.status === 200) {
      if (response.data.error != 2) {
        return response.data;
      } else {
        removeLocalStorage();
        window.location.href = '/';
      }
    } else {
      throw new Error(response.statusText);
    }
  } catch (error) {
    console.error(error);
    throw error;
  }
});

export const updateNextPlan = createAsyncThunk('enhance-dispute/updateNextPlan', async ({ planId, mailingOption }) => {
  let accessToken = localStorage.getItem('accessToken');
  let formData = new FormData();
  formData.append('Token', accessToken);
  formData.append('plan_id', planId);
  formData.append('mailing_option', mailingOption);
  let response = await axios.post('form/setNextRoundPlan', formData);
  if (response.status === 200) {
    if (response.data.error != 2) {
      return response.data;
    } else {
      removeLocalStorage();
      window.location.href = '/';
    }
  } else {
    throw new Error(response.statusText);
  }
});

const removeLocalStorage = () => {
  localStorage.removeItem('username');
  localStorage.removeItem('isAdmin');
  localStorage.removeItem('company_id');
  localStorage.removeItem('company_logo');
  localStorage.removeItem('accessToken');
};

const enchanceDisputeSlice = createSlice({
  name: 'enchance-dispute',
  initialState,
  reducers: {
    blankCurrentPlan: state => {
      state.currentPlan = '';
      state.mailingOption = '';
      state.nextMailingOption = '';
      state.currentPlanStatus = 'idle';
    },
  },
  extraReducers: builder => {
    builder.addCase(fetchCurrentPlan.fulfilled, (state, action) => {
      state.currentPlanStatus = 'succeeded';
      state.mailingOption = eval(action.payload.response.mailing_option);
      state.nextMailingOption = eval(action.payload.response.next_mailing_option);
      state.currentPlan = action.payload.response.current_plan;
      state.nextPlan = action.payload.response.next_round_plan;
      state.packages = action.payload.response?.packages_prices;
      state.firstName = action.payload.response?.client_fname;
      state.currentPlanStatusError = '';
    });
    builder.addCase(fetchCurrentPlan.rejected, (state, action) => {
      state.currentPlanStatus = 'failed';
      state.currentPlan = '';
      state.nextPlan = '';
      state.mailingOption = '';
      state.nextMailingOption = '';
      state.packages = {};
      state.currentPlanStatusError = 'Error while fetching current plan';
    });
    builder.addCase(updateCurrentPlan.fulfilled, (state, action) => {
      state.currentPlanStatus = 'updated.success';
      state.currentPlanStatusMsg = action.payload.msg;
    });
    builder.addCase(updateCurrentPlan.rejected, (state, action) => {
      state.currentPlanStatus = 'updated.failed';
      state.currentPlanStatusMsg = 'Plan update failed';
      // state.currentPlan = action.payload.response.current_plan;
    });
    builder.addCase(updateNextPlan.fulfilled, (state, action) => {
      state.currentPlanStatus = 'updated.success';
      state.currentPlanStatusMsg = action.payload.msg;
    });
    builder.addCase(updateNextPlan.rejected, (state, action) => {
      state.currentPlanStatus = 'updated.failed';
      state.currentPlanStatusMsg = 'Plan update failed';
      // state.currentPlan = action.payload.response.current_plan;
    });

    builder.addCase(fetchPackagesDetail.fulfilled, (state, action) => {
      state.packagesDetail = Object.values(action.payload).map(item => item[0]);
    });
  },
});

export const { blankCurrentPlan } = enchanceDisputeSlice.actions;

export default enchanceDisputeSlice.reducer;
